import { jsx as o } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useResponsiveViewport as R, mediaQueries as x } from "../../../../../hooks/useResponsiveViewport.js";
import b from "../../../Popover/Popover.js";
import { PopoverContainerSize as w, PopoverContainerVariant as A, PopoverContainerPosition as V } from "../../../Popover/types.js";
import g from "../../../../../core/Context/useCoreContext.js";
import a from "classnames";
import { memo as h } from "../../../../../external/preact/compat/dist/compat.module.js";
import { useMemo as l } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { DROPDOWN_LIST_CLASS as F, DROPDOWN_LIST_ACTIVE_CLASS as W, DROPDOWN_ELEMENT_CLASS as z, DROPDOWN_ELEMENT_NO_OPTION_CLASS as j } from "../constants.js";
import y, { renderListItemDefault as B } from "./SelectListItem.js";
import { fixedForwardRef as Q } from "../../../../../utils/preact/fixedForwardRef.js";
import { isFunction as U } from "../../../../../utils/value/is.js";
import { boolOrFalse as $ } from "../../../../../utils/value/bool.js";
const k = Q(
  ({
    active: c,
    commitActions: p,
    items: d,
    multiSelect: s,
    onKeyDown: f,
    onSelect: u,
    renderListItem: t,
    selectListId: O,
    showList: i,
    textFilter: n,
    toggleButtonRef: S,
    dismissPopover: C,
    setToTargetWidth: N,
    popoverClassNameModifiers: P,
    showOverlay: _,
    fitPosition: D
  }, E) => {
    const { i18n: L } = g(), T = R(x.down.xs), m = d.filter((e) => !n || e.name.toLowerCase().includes(n)), v = a(F, { [W]: i }), M = a(z, j), I = l(() => U(t) ? t : B, [t]), r = l(() => $(s), [s]);
    return i ? /* @__PURE__ */ o(
      b,
      {
        classNameModifiers: P,
        actions: r ? p : void 0,
        disableFocusTrap: !0,
        divider: !0,
        dismiss: C,
        dismissible: !1,
        open: i,
        setToTargetWidth: N,
        containerSize: w.MEDIUM,
        variant: A.POPOVER,
        targetElement: S,
        withContentPadding: !1,
        position: V.BOTTOM,
        showOverlay: _ && T,
        fitPosition: D,
        children: /* @__PURE__ */ o("ul", { className: v, id: O, ref: E, role: "listbox", "aria-multiselectable": r, children: m.length ? m.map((e) => /* @__PURE__ */ o(
          y,
          {
            item: e,
            multiSelect: r,
            onKeyDown: f,
            onSelect: u,
            renderListItem: I,
            selected: c.includes(e)
          },
          e.id
        )) : /* @__PURE__ */ o("div", { className: M, children: L.get("select.noOptionsFound") }) })
      }
    ) : null;
  }
), se = h(k);
export {
  se as default
};
